export default "__VITE_PUBLIC_ASSET__421238e5__"